export default {
    SET_ADMIN_TYPES: (state, types) => {
        state.configTypes.admin = types;
    },

    SET_BOSS_TYPES: (state, types) => {
        state.configTypes.boss = types;
    },

    SET_ITEMS: (state, items) => {
        state.items = items;
    }
};
